import React, { useContext, useEffect, useRef, useState } from "react";
import cardImg from "../../assets/images/mediaCenter.png";
import { getHome } from "../../utils/apiCalls";
import moment from "moment";
import { FormContext } from "../CMSRenderer/CMSRenderer";
import { getTranlation } from "../CMSRenderer/function";
import "moment/locale/ar";

const Home = ({ config }) => {
  const [selectedBannerIdx, setSelectedBannerIdx] = useState(null);
  const { currentLang } = useContext(FormContext);
  const carouselRef = useRef(null);
  const [loading, setLoading] = useState({
    bannerLoading: true,
    newsLoading: true,
  });
  const [news, setNews] = useState([]);
  const [banner, setBanner] = useState([]);
  const bannerCardListRef = useRef(
    currentLang == "en"
      ? config?.props?.bannerCard
      : getTranlation({ config: config })?.props?.bannerCard || []
  );

  useEffect(() => {
    getHome().then((res) => {
      if (res?.data.homeBanners) {
        setBanner(res?.data?.homeBanners);
      }
      setLoading({
        ...loading,
        bannerLoading: false,
        newsLoading: false,
      });
    });
  }, []);

  const filteredBanners = banner.filter((bannerItem) => {
    if (currentLang === "en") {
      return bannerItem.showInEn === true;
    } else if (currentLang === "ar") {
      return bannerItem.showInAr === true;
    }
    return false;
  });

  const getMediaType = (mediaPath) => {
    if (!mediaPath) return 'image';
    const videoExtensions = ['.mp4', '.mov'];
    const ext = mediaPath.toLowerCase().substring(mediaPath.lastIndexOf('.'));
    return videoExtensions.includes(ext) ? 'video' : 'image';
  };

  const renderMedia = (mediaPath) => {
    const mediaType = getMediaType(mediaPath);
    const mediaSrc = "/" + mediaPath;

    if (mediaType === 'video') {
      return (
        <video 
          muted 
          playsInline 
          loop 
          className="w-full h-full object-cover"
        >
          <source src={mediaSrc} type={`video/${mediaPath.split('.').pop()}`} />
          Your browser does not support the video tag.
        </video>
      );
    } else {
      return (
        <img
          src={mediaSrc}
          alt="banner"
          className="w-full h-full object-cover"
        />
      );
    }
  };

  const bannerDetailsRef = useRef(null);

  useEffect(() => {
    const carousel = carouselRef.current;
    if (!carousel) return;

    const handler = (e) => {
      const clickedId = e.detail;

      const idx = bannerCardListRef.current.find(
        (item) => item.banner_card_id === clickedId?.banner_card_id
      );

      if (idx !== -1) {
        setSelectedBannerIdx(idx);
        setTimeout(() => {
          if (bannerDetailsRef.current) {
            const elementTop =
              bannerDetailsRef.current.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
              top: elementTop - 400, // 👈 offset of 400px from top
              behavior: "smooth",
              block: "start",
            });
          }
        }, 100);
      }
    };

    carousel.addEventListener("cardClick", handler);
    return () => carousel.removeEventListener("cardClick", handler);
  }, []);

  return (
    <>
      <style jsx>{`
        .dda-home-banner-slider-nav-content{margin-bottom: 20px}
      `}</style>

      {loading?.bannerLoading ? (
        <div
          role="status"
          className="text-center text-primary min-h-[100vh] animate-pulse bg-gray-300 w-full rounded-lg"
          key={"09"}
        >
          <div className="flex items-center justify-center w-full h-[100vh] rounded-lg bg-gray-400">
            <svg
              className="w-10 h-10 text-gray-200 "
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 18"
            >
              <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
            </svg>
          </div>
          <div className="w-full p-3">
            <div className="h-2.5 bg-gray-200 rounded-full w-1/2"></div>
          </div>
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <dda-home-banner autoplay="true" interval="4000">
        {filteredBanners.map((items, index) => {
          const currentMedia = currentLang === "en" ? items?.mediaEn : items?.mediaAr;
          return (
            <div className="dda-home-banner-slide" key={index}>
              {renderMedia(currentMedia)}
              <div className="dda-slide-contant-wrap">
                <div className="dda-slide-contant">
                  <div style={{ width: "50%" }}>
                    <h3 className="text-white">
                      {currentLang === "en"
                        ? items?.titleEn || ""
                        : items?.titleAr || ""}
                    </h3>
                    <h5 className="mb-5 mt-2 text-white">
                      {currentLang === "en"
                        ? items?.descriptionEn || ""
                        : items?.descriptionAr || ""}
                    </h5>
                    <div className="flex gap-4 flex-wrap">
                      {items?.primaryBtnTextEn &&
                      items?.primaryBtnTextEn !== "" ? (
                        <dda-button
                          button_color="default-secondary"
                          start_icon=""
                          button_text={
                            currentLang === "en"
                              ? items?.primaryBtnTextEn || ""
                              : items?.primaryBtnTextAr || ""
                          }
                          end_icon=""
                          custom_class="homeBannerButton"
                          component_mode=""
                          button_id="button"
                          aria_label="button"
                          onclick={() =>
                            eval(
                              `window.location.href = '${
                                currentLang === "en"
                                  ? items?.primaryBtnLinkEn || ""
                                  : items?.primaryBtnLinkAr || ""
                              }'`
                            )
                          }
                          button_name="button"
                        ></dda-button>
                      ) : null}
                      {items?.secondaryBtnTextEn || items?.secondaryBtnTextAr && items?.secondaryBtnTextEn || items?.secondaryBtnTextAr !== "" ? (
                        <dda-button
                          button_color="default-secondary"
                          start_icon=""
                          button_text={currentLang === "en" ? items?.secondaryBtnTextEn : items?.secondaryBtnTextAr}
                          end_icon=""
                          custom_class="homeBannerButton"
                          component_mode=""
                          button_id="button"
                          aria_label="button"
                          onclick={() =>
                            eval(
                              `window.location.href = '${
                                currentLang === "en"
                                  ? items?.secondaryBtnLinkEn || ""
                                  : items?.secondaryBtnLinkAr || ""
                              }'`
                            )
                          }
                          button_name="button"
                        ></dda-button>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        </dda-home-banner>
      )}

      <div className="dda-home-quick-links-wrap ">
        <div className="dda-home-quick-links">
          <dda-home-carousel
            ref={carouselRef}
            items_in_view="5"
            bannercardlist={JSON.stringify(bannerCardListRef.current)}
            custom_class="cursor-pointer pt-20"
          ></dda-home-carousel>
        </div>
      </div>

      {selectedBannerIdx !== null && (
        <div className="my-9 md:w-[90vw] m-auto px-[20px]">
          <div className="md:flex justify-between mb-8">
            <h3 className="dda-h3 Medium text-primary">{currentLang === 'en' ? selectedBannerIdx.banner_card_title : selectedBannerIdx.banner_card_title_ar}</h3>
            <div className="text-end">
              <dda-button
                button_color="default-primary"
                start_icon=""
                button_text={currentLang === 'en' ? "View All Services" : "عرض جميع الخدمات"}
                end_icon=""
                custom_class="px-8"
                component_mode=""
                button_id="button"
                aria_label="button"
                onclick={() => (window.location.href = `/services?type=${selectedBannerIdx.type}`)}
                button_name="button"
            ></dda-button>
            </div>
          </div>
          <div
            ref={bannerDetailsRef}
            className="grid lg:grid-cols-3 md:grid-cols-2 gap-4 "
          >
            {selectedBannerIdx?.detail.map((detail, i) => (
              <dda-image-card
                key={i}
                image_src={detail.image_src}
                header_text={
                  currentLang === "en"
                    ? detail.header_text
                    : detail.header_text_ar
                    ? detail.header_text_ar
                    : detail.header_text
                }
                left_button_name={
                  currentLang === "en"
                    ? detail.left_button_name
                    : detail.left_button_name_ar
                    ? detail.left_button_name_ar
                    : detail.left_button_name
                }
                left_button_href={detail.left_button_href}
                custom_class="home-service-card"
                component_mode=""
                image_alt="alternate text"
                left_button_color="default-tertiary"
              ></dda-image-card>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

const HomeApp = ({ config }) => {
  const { currentLang } = useContext(FormContext);
  return (
    <>
      <div className="grid md:grid-cols-2 gap-10 items-center md:my-20 my-10 bg-[#E4EFF3] p-10 rounded-2xl">
        <div>
          <h6 className="text-primary">
            {currentLang === "en"
              ? config.mobile_title
              : config.mobile_title_ar
              ? config.mobile_title_ar
              : config.mobile_title}
          </h6>
          <h2 className="my-3">
            {currentLang === "en"
              ? config.mobile_subtitle
              : config.mobile_subtitle_ar
              ? config.mobile_subtitle_ar
              : config.mobile_subtitle}
          </h2>
          <h6 className="text-onSurfaceVariant">
            {currentLang === "en"
              ? config.mobile_body
              : config.mobile_body_ar
              ? config.mobile_body_ar
              : config.mobile_body}
          </h6>
          <div className="flex gap-5 my-5">
            <a
              href={config.mobile_ios_link || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className=""
            >
              <img
                src="/attachments/medialib/134db5cb-46c3-4251-90c3-38e031a27b2e-1759477259052-338182874-App Store.png"
                alt="Apple Logo"
                className="h-[50px]"
              />
            </a>
            <a
              href={config.mobile_android_link || "#"}
              target="_blank"
              rel="noopener noreferrer"
              className=""
            >
              <img
                src="/attachments/medialib/0d95fb51-09b4-4a09-aa74-25b678284479-1759477130822-378344005-Google Play.png"
                alt="Google Play"
                className="h-[50px]"
              />
            </a>
            
          </div>
        </div>
        <img
          src={currentLang === "en"
              ? config.app_image
              : config.app_image_ar
              ? config.app_image_ar
              : config.app_image}
          alt="Devices"
          className="md:ms-auto mx-auto md:mx-0 max-h-[370px]"
        />
      </div>
    </>
  );
};

const HomeNews = ({ config }) => {
  const { currentLang } = useContext(FormContext);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState({
    bannerLoading: true,
    newsLoading: true,
  });

  useEffect(() => {
    getHome().then((res) => {
      if (res?.data?.news) {
        setNews(res?.data?.news);
      }

      setLoading({
        ...loading,
        bannerLoading: false,
        newsLoading: false,
      });
    });
  },[]);

  return (
    <div className="my-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="">
            {currentLang === "en"
              ? config.latest_media
              : config.latest_media_ar
              ? config.latest_media_ar
              : config.latest_media}
          </h2>
          {!!config.latest_media_body && (
            <h6 className="text-onSurfaceVariant my-2">
              {currentLang === "en"
                ? config.latest_media_body
                : config.latest_media_body_ar
                ? config.latest_media_body_ar
                : config.latest_media_body}
            </h6>
          )}
        </div>

        <div>
          {!loading?.newsLoading && news.length > 0 && (
            <dda-button
              button_color="default-primary"
              start_icon=""
              button_text={
                currentLang === "en"
                  ? config.media_button
                  : config.media_button_ar
              }
              end_icon=""
              custom_class="px-8"
              component_mode=""
              button_id="button"
              aria_label="button"
              onclick={() => (window.location.href = "/mediaCenter")}
              button_name="button"
            ></dda-button>
          )}
        </div>
      </div>
      {loading?.newsLoading ? (
        <div
          role="status"
          className="text-center text-primary min-h-[400px] animate-pulse bg-gray-300 w-full rounded-lg"
          key={"09"}
        >
          <div className="flex items-center justify-center w-full h-[400px] rounded-lg bg-gray-400">
            <svg
              className="w-10 h-10 text-gray-200 "
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 18"
            >
              <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
            </svg>
          </div>
          <div className="w-full p-3">
            <div className="h-2.5 bg-gray-200 rounded-full w-1/2"></div>
          </div>
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 my-5 gap-7">
          {news?.length > 0 && (
            <a href={`/mediaCenter/mediaCenterDetails/${news?.[0]?.dguid || ""}`}>
              <dda-image-card
                image_src={"/" + news?.[0]?.image || cardImg}
                custom_class="border-0 shadow-none home-image-card"
                component_mode=""
                class="hydrated"
              >
                <div className="-mt-2">
                  <p className="text-primary body">
                    {moment(new Date(news?.[0]?.publishDate))?.locale(currentLang === "en" ? "en" : "ar")
                  .format("dddd, MMMM DD, YYYY")
                  .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
                  .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) || ""}
                  </p>
                  <h5 className="my-2">
                    {currentLang === "en"
                      ? news?.[0]?.titleEn
                      : news?.[0]?.titleAr || ""}
                  </h5>
                  <p className="body text-onSurfaceVariant">
                    {currentLang === "en"
                      ? news?.[0]?.shortDescriptionEn
                      : news?.[0]?.shortDescriptionAr || ""}
                  </p>
                </div>
              </dda-image-card>
            </a>
          )}
          <div className="flex flex-col justify-between ">
            {news?.length > 0 &&
              news?.slice(1)?.map((newItem, index) => (
                <a
                  key={index}
                  href={`/mediaCenter/mediaCenterDetails/${newItem?.dguid || ""}`}
                  className="flex bg-white rounded-xl overflow-hidden mb-4 home-news-wide"
                >
                  <img
                    src={"/" + newItem?.image || cardImg}
                    alt="media"
                    className="w-1/4 h-full object-cover rounded-s-lg"
                  />
                  <div className="p-3 flex flex-col justify-center news-side-content">
                    <p className="text-primary body mb-1 font-medium">
                      {moment(new Date(newItem?.publishDate))?.locale(currentLang === "en" ? "en" : "ar")
                  .format("dddd, MMMM DD, YYYY")
                  .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
                  .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) || ""}
                    </p>
                    <h5 className=" mb-1">
                      {currentLang === "en"
                        ? newItem?.titleEn
                        : newItem?.titleAr}
                    </h5>
                    <p className="body text-onSurfaceVariant line-clamp-2">
                      {currentLang === "en"
                        ? newItem?.shortDescriptionEn
                        : newItem?.shortDescriptionAr}
                    </p>
                  </div>
                </a>
              ))}
          </div>
        </div>
      )}
      {/* <div className="flex justify-center my-8">
        
      </div> */}
    </div>
  );
};

export { Home, HomeNews, HomeApp };
